module.exports = "img/videos/1.2149a1.mp4";